<template>
  <div id="tooltip" v-show="visible" :style="{ top: top + 'px', left: left + 'px', 'z-index': 1000 }">
    <template v-if="title && title !== 'meta tooltip'">
      <p class="tt-text tt-title">{{ title }}</p>
      <p class="tt-text tt-subtitle">{{ subtitle }}</p>
      <hr>
      <p>{{ value | digitGrouping }}</p>
    </template>
    <template v-else>
      <p class="brush">{{ value }}</p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'tooltip',

  props: ['visible', 'top', 'left', 'title', 'subtitle', 'value'],

  data () {
    return {
    }
  }
}
</script>

<style scoped>
#tooltip {
  position: absolute;
  max-width: 350px;
  height: auto;
  padding: 10px;
  background-color: white;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -webkit-box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.4);
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.4);
  pointer-events: none;
}

p {
  text-align: center;
  margin: 0;
  font-family: sans-serif;
  font-size: 16px;
  line-height: 20px;
}

p.brush {
  text-align: left;
  font-size: 13px;
  line-height: 14px;
}

hr {
  opacity: .5;
  margin: .3em 0 .5em;
}
.tt-text {
  font-size: 14px;
}
.tt-title {
  font-weight: bold;
}
.tt-subtitle {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/Tooltip.vue